import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import { param } from '@/redux/selectors/uiSelectors.js';
import routes from '@/routes.js';
import { useSelector } from 'react-redux';

const usePresenceId = () => {
  const appId = useArgSelector(param, 'appId');
  const appVersion = useArgSelector(param, 'appId');
  const workflowId = useArgSelector(param, 'workflowId');
  const jobId = useArgSelector(param, 'jobId');

  const activeRouteId = useSelector((state) => state.ui.activeRouteId);
  const activeRouteSlug = routes.find((n) => n.id === activeRouteId)?.routeId;

  let presenceId = null;

  if (activeRouteSlug === 'jobs' && jobId) {
    presenceId = `${activeRouteSlug}-${jobId}`;
  }

  if (activeRouteSlug === 'apps' && appId && appVersion !== undefined) {
    presenceId = `${activeRouteSlug}-${appId}-${appVersion}`;
  }

  if (activeRouteSlug === 'workflows' && workflowId) {
    presenceId = `${activeRouteSlug}-${workflowId}`;
  }

  if (activeRouteSlug === 'monitoring') {
    presenceId = `${activeRouteSlug}`;
  }

  if (activeRouteSlug === 'settings') {
    presenceId = `${activeRouteSlug}`;
  }

  return presenceId;
};

export default usePresenceId;
